export default __webpack_public_path__ + "static/media/logo-white.c4adee1b.svg";